module.exports = __webpack_public_path__ + "static/transformation-bg-v3-e39567e356c1633e0bd26c6081406aed.jpg";